<template>
  <v-app>
    <app-header />
    <v-content>
      <hero-banner />
      <request-form />
      <carousel />
      <app-footer />
    </v-content>
  </v-app>
</template>

<script>
  import Header from './components/Header';
  import HeroBanner from './components/HeroBanner';
  import Form from './components/Form'
  import Footer from './components/Footer'
  import Carousel from './components/Carousel'

  export default {
    name: 'App',

    components: {
      'AppHeader': Header,
      HeroBanner,
      'RequestForm': Form,
      'AppFooter': Footer,
      Carousel
    },

    data: () => ({
      //
    }),
  };
</script>

<style lang="scss">
  @font-face {
    font-family: fruity-solid;
    src: url('./assets/fonts/kgsecondchancessolid-webfont.woff2') format('woff2'),
    url('./assets/fonts/kgsecondchancessolid-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

  }
  .v-application {
    font-family: 'Montserrat',sans-serif !important;
  }
</style>
